import { render, staticRenderFns } from "./airbnb.vue?vue&type=template&id=159661c6&scoped=true&"
import script from "./airbnb.vue?vue&type=script&lang=js&"
export * from "./airbnb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159661c6",
  null
  
)

export default component.exports